// src/components/common/PageContainer.js

import React from 'react';

const PageContainer = ({ title, actionButton, headerActions, children }) => {
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-0">
          {title}
        </h1>
        <div className="flex items-center space-x-2">
          {/* This is where the custom actions will render */}
          {headerActions}
          
          {/* This is for the default "Add New" button */}
          {actionButton}
        </div>
      </div>
      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md">
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
